import { render } from "./deposit-request-info.vue?vue&type=template&id=8531b1a8&scoped=true&ts=true"
import script from "./deposit-request-info.vue?vue&type=script&lang=ts"
export * from "./deposit-request-info.vue?vue&type=script&lang=ts"

import "./deposit-request-info.vue?vue&type=style&index=0&id=8531b1a8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8531b1a8"]])

export default __exports__